module.exports = __webpack_public_path__ + "static/img/d6t_pc.2a52f410.jpg";